<template>
    <div style="margin-top: -20px;margin-left: 30px;width: 900px;" >
        <el-menu :default-active="activeIndex"  class="el-menu-vertical-demo" mode="horizontal" @select="handleOpen"  >
            <el-menu-item index="0">
                <span>基本设置</span>
            </el-menu-item>

            <el-menu-item index="3" >
                <span slot="title">应用绑定</span>
            </el-menu-item>
            <!--<el-menu-item index="4">-->
                <!--<span slot="title">关联账号</span>-->
            <!--</el-menu-item>-->
            <el-tooltip class="item" effect="light" placement="left" :value=true>
                <div slot="content" style="color: #F56C6C;font-size: 14px"><b><i class="el-icon-message-solid"></i>修改配置后请点击此处保存</b></div>
                <el-button style="text-align: center;float: right;margin-top: 26px" type=primary size="small" @click="submit">确定</el-button>
            </el-tooltip>
        </el-menu>

            <basic-configure v-if="activeIndex == 0 " :head_params="params" :params="form.basic_configure" ref="basic-configure" :domain_suffix='domain_suffix' @getMemo="getMemo" @handleDataInit='handleDataInit'>
                <template slot="head">
                    <product-head :params="params" @changeHead="changeHead"></product-head>
                </template>
            </basic-configure>
            <app-bind v-if="activeIndex == 3 " :params="form.app_bind" ref="app_bind" @handleSubmitAppBind='handleSubmitAppBind' :app_data="app_data"></app-bind>
            <div v-if="activeIndex == 4">
                <relation-form :product="params.product_code" service="xwt" :customerId="$route.query['id']" already-relation="true">
                    <template slot="button">
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="mini" @click="showRelation=true">关联账号</el-button>
                        <relation-dialog :product="params.product_code" title="关联账号" @handleClose="closeRelationDialog" :customerId="$route.query['id']" :is-show="showRelation" ></relation-dialog>
                    </template>
                </relation-form>
            </div>
    </div>
</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }
</style>
<script>
import BasicConfigure from  "~/views/order/jiaoben/basicConfigure.vue";
import AppBind from  "~/views/order/jiaoben/appBind.vue";
import CommonService from "~/services/common";
import RelationForm from "~/views/customer/relationForm.vue";
import RelationDialog from "~/views/customer/dialog/relationDialog.vue";
import AccountService from "~/services/CustomerAccounts"
import ProductHead from  "~/views/order/partial/product_head.vue";
import OrderService from "~/services/order";
import Params from "~/config/params";

export default {
    components:{
        BasicConfigure,
        AppBind,
        CommonService,
        RelationForm,
        RelationDialog,
        ProductHead
    },
    data() {
        return {
            form:{
                order_id:'',
                product_id:'',
                app_bind:[],
                basic_configure:{},
                memo:''
            },
            showRelation:false,
            validate_basic_configure:true,
            is_ajax_loading:false,
            validate_app_bind:false,
            domain_suffix:'21cnjy.net',
            activeIndex:'0',
            formLabelWidth:'120px',
            app_data:[]
        };
    },
    props:{
            params:{
                required:true
            }
    },
    created(){

        this.form = Object.assign(this.form,this.params.config)
        this.form.order_id = this.params.order_id;
        this.form.product_id = this.params.product_id;
        this.form.type = this.params.open_state;
        this.form.end_at = this.params.end_at;
        this.form.start_at = this.params.start_at;
    },
    mounted() {
        this.getApp();
    },
    methods:{
        submit(){
            if(this.form.app_bind.length==0){
                this.$message({
                    message: '应用绑定不能为空',
                    type: 'error'
                });
                return false;
            }
            if(!this.validate_basic_configure) return false;
            if(this.is_submit) return false;
             this.is_submit = true;
            OrderService.reviseProduct(this.form).then(res => {
                if (res.code == 0) {
                    this.$message({
                        message: res.msg=='success'?Params.REVISE_NOTICE:res.msg,
                        type: 'success'
                    });
                }
                this.is_submit = false;
            });
        },
        /**
         * 修改头部信息
         * @param data
         */
        changeHead(data){
            this.form.type = data.type;
            this.form.end_at = data.end_at;
            this.form.start_at = data.start_at;
        },
        closeRelationDialog(show){
            this.showRelation = show;
        },
        /**
         * 关联账号
         * */
        relationAccount(data){
            let uids = [];
            data.forEach(item=>{
                uids.push(item.uid);
            })
            AccountService.batchSetGroup({uids:uids,group_id:this.currentOption}).then(res=>{
                if(res.code==0){
                    this.getCurrentAccounts();
                }
            })
        },
        handleDialogConfigureClose(){
            this.$emit('handleDialogConfigureShow','',this.form.product_id);
        },
        handleDialogConfigureShow(){
            if(!this.validate_basic_configure){
                this.$message({
                    message:'请进行基本设置或者基本设置错误',
                    type:'error'
                })
                return false;
            }
            this.$emit('handleDialogConfigureShow',this.form);
        },
        handleOpen(key, keyPath) {
            this.activeIndex = key;
        },
        handleSubmitAppBind(params){
            this.form.app_bind = params;
        },
        handleDataInit(data){
            this.is_ajax_loading = true;
            this.validate_basic_configure = false;
            this.form.memo = data.memo
            this.$refs['basic-configure'].validateForm((rs)=>{
                this.validate_basic_configure = rs;
                this.is_ajax_loading = rs;
            })
            this.form.basic_configure = data;
        },
        getMemo(data) {
            this.form.memo = data.memo
        },
        getApp(){
            CommonService.getJbApp().then(res=>{
                this.app_data = res.data;
            })
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/views/order/officialWebsiteConfigure.vue